import ViewClaim from 'components/ViewClaims/ViewClaims.component';

const ViewClaims = () => {
	return <ViewClaim />;
};

export default ViewClaims;
